module.exports = __webpack_public_path__ + "img/desktop_about_hero_img.aca31c56.png";